import $ from 'jquery';
import './v2a-tiny-rte.jquery';

$(function () {
    $('.tiny-rte').tinyRte();
});
